import type { ServerOptions } from 'https';
import type { IncomingMessage, ServerResponse } from 'http';

/**
 * HTTPS server configuration settings.
 */
export type HttpsConfig = Omit<
  ServerOptions<typeof IncomingMessage, typeof ServerResponse>,
  // These are irrelevant for usage and cause problems for schema generation.
  'IncomingMessage' | 'ServerResponse'
>;
